import { render } from "./TDSettings.vue?vue&type=template&id=e1137960"
import script from "./TDSettings.vue?vue&type=script&lang=js"
export * from "./TDSettings.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__